import { StepName } from '@/state/state.types';

export const isXLContainer = (stepId: string): boolean => {
  return [StepName.product].some((id) => stepId.startsWith(id));
};
